<template>
  <div>
    {{ $t('message.LOGGING_OUT') }}
  </div>
</template>

<script>
export default {
  name: 'Logout',

  beforeRouteEnter(to, from, next) {
    // TODO Handle logout procedure here instead of App.vue.
    // To handle logout here, we need to move meeting variables in the Vuex store.
    // Right know, it's catch on NavItem components, in router-links:
    // If it's a `/logout` link, it will call the `logout` method from App.vue.
    next(false);
  },
};
</script>
